module.exports = __webpack_public_path__ + "static/media/close-circle.917454f4.svg";